module.exports = __webpack_public_path__ + "img/Kibar.71637cf8.webp";